<template>
    <section class="contenedor-notificacion" v-if="estado">
        <div class="notificacion">
            <div class="contenedor-informacion">
                <p>{{ mensaje }}</p>

                <button class="boton-cerrar" @click="cerrarNotificacion()">
                    <img src="../../assets/icons/icono cerrar naranja.svg" alt="icono cerrar">
                </button>
            </div>
        </div>
    </section>
</template>

<script>

export default {
    name: 'notificacion',

    components: {
    },

    data() {
        return {
        }
    },

    computed: {
        estado(){
            let datos = this.$store.getters.getNotification;
            return datos.estado;
        },

        mensaje(){
            let datos = this.$store.getters.getNotification;
            return datos.mensaje;
        }
    },

    mounted() {
    },

    methods: {
        cerrarNotificacion: function(){
            this.$store.commit("setNotification", { estado: false, mensaje: '' });
        }
    }
}
</script>

<style lang="scss">
.contenedor-notificacion {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 80px;
    left: 0;
    z-index: 20;

    .notificacion {
        width: 100%;
        max-width: 770px;
        height: 56px;
        padding: 0 20px;
        border-radius: 15px;
        background-color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;

        .contenedor-informacion {
            width: 100%;
            height: 36px;
            padding: 0 15px;
            border: 1px dashed #E47A3A;
            border-radius: 10px;
            display: flex;
            align-items: center;

            p {
                margin: 0;
                font-family: 'Source Sans Pro', sans-serif;
                font-size: 14px;
                font-weight: lighter;
                color: #E47A3A;
                text-align: left;
            }

            .boton-cerrar {
                width: 18px;
                height: 18px;
                margin-left: auto;
                border: 0;
                border-radius: 50%;
                background: transparent;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    width: 18px;
                    height: 18px;
                }
            }
        }
    }
}
</style>